var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/logo/logo_agile.svg"),
          alt: "agile logo",
        },
      }),
      _c("span", { staticClass: "text" }, [_vm._v("Mobility Solutions")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }